module.exports = __webpack_public_path__ + "public/1.0.1_626420/img/图片3.92ba091a.png";